const sns = {};

// 该方法可能存在遗漏，仅为临时解决PC环境下字体问题使用，后续PC需切换到PC详情页
function isMobile() {
  var userAgent = navigator.userAgent || window.opera;
  // 匹配常见的移动设备操作系统  
  if (/windows phone/i.test(userAgent)) {
    return true;
  }
  if (/android/i.test(userAgent)) {
    return true;
  }
  // iOS 设备  
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return true;
  }
  // 黑莓  
  if (/BlackBerry/i.test(userAgent)) {
    return true;
  }
  // Opera mini  
  if (/Opera Mini/i.test(userAgent)) {
    return true;
  }
  return false;
}
function initFontSize() {
  let sizeRate = 100;
  if (isMobile()) {
    sizeRate = (document.documentElement.clientWidth / 375.0) * 100;
  }
  if (sizeRate === 0 || sizeRate > 160) {
    sizeRate = 100;
  }
  document.getElementsByTagName('html')[0].style.fontSize = sizeRate + 'px';
  document.getElementsByTagName('html')[0].classList.add('fontinit');
  return sizeRate;
}
sns.initFontSize = initFontSize;

export { initFontSize, sns };
